import { FlexBox, Text } from '@dixa/lib-shared-habla';
import type { MainConversation } from 'lib-shared-types-api';

import { ConversationChip } from 'components/conversation/conversationChip';
import { getConversationTitle } from 'utils/conversation';

type ConversationPreviewDetailsProps = {
  conversation: MainConversation;
};

export const ConversationPreviewDetails = ({
  conversation,
}: ConversationPreviewDetailsProps): JSX.Element => {
  const requester = conversation.authors[conversation.requested_by];

  const title = getConversationTitle({
    channel: conversation.initial_channel,
    direction: conversation.direction,
    subject: conversation.attributes.subject,
    requester,
  });

  return (
    <FlexBox flexDirection="row" alignItems="center" gap="300">
      <ConversationChip
        csid={conversation.id}
        channel={conversation.initial_channel}
        status={conversation.status}
        popoverContentProps={{
          side: 'right',
        }}
      />

      <FlexBox flexDirection="column" flex="1" alignSelf="center">
        <Text.Paragraph variant="1">{title}</Text.Paragraph>
      </FlexBox>
    </FlexBox>
  );
};
